// adds a KV record as query params, while filtering out falsy values
export function addQueryParams(url: string, params: Record<string, string | number | boolean>) {
	const urlObj = new URL(url);
	for (const [key, value] of Object.entries(params)) {
		if (!value) {
			continue;
		}
		urlObj.searchParams.set(key, value.toString());
	}
	return urlObj.toString();
}
